/* Respyr cart helpers.
   1) Free first filter pack (Appstle Bundles "Buy Mask, Get Filters Free" offer).
      The offer only applies to cart lines tagged with the offer properties, so this script
      keeps the tags on ONLY when the cart has the mask AND a Subscribe & Save filter:
      - mask + subscribed filter without tags  -> both re-added with the tags (free pack)
      - tags present but the filter isn't subscribed, or the mask/filter is missing
                                               -> tagged lines re-added without tags (no free pack)
      Subscriptions keep their delivery schedule when lines are re-added.
      After re-adding, the page reloads (and reopens the drawer) so everything shows the updated cart.
   2) Hide "Complete your kit" cards for products already in the cart.
   3) "First 4-pack free" call-out on the filter card in "Complete your kit" (only when the mask is in the cart).
   4) On pages with the Respyr purchase box, the sticky bar's "Add to Cart" scrolls to the purchase box
      instead of adding the product directly (so shoppers always see Subscribe & Save vs. One-time). */
(function () {
  var MASK_VARIANT = 43140538400977;
  var FILTER_VARIANT = 43087438676177;
  var OFFER = { '_appstle-bb-id': 'zcxekamm2v', '_appstle_bundles_type': 'BUY_X_GET_Y', '__appstle-bb-name': 'The Respyr System' };
  var KEY = '_appstle-bb-id';
  var FLAG = 'rpbGuardRan';
  var busy = false;
  var origFetch = window.fetch.bind(window);

  function json(url, body) {
    return origFetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json(); });
  }
  function getFlag() { try { return sessionStorage.getItem(FLAG); } catch (e) { return null; } }
  function setFlag(v) { try { v ? sessionStorage.setItem(FLAG, v) : sessionStorage.removeItem(FLAG); } catch (e) {} }

  function drawerOpen() {
    var store = window.Alpine && window.Alpine.store && window.Alpine.store('modal');
    return !!(store && store.id === 'modal--cart-drawer');
  }

  function toItem(line, tagged) {
    var item = { id: line.variant_id, quantity: line.quantity };
    if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan) {
      item.selling_plan = line.selling_plan_allocation.selling_plan.id;
    }
    if (tagged) item.properties = OFFER;
    return item;
  }

  function rebuild(lines, items) {
    var reopen = drawerOpen();
    var updates = {};
    lines.forEach(function (i) { updates[i.key] = 0; });
    return json('/cart/update.js', { updates: updates })
      .then(function () { return json('/cart/add.js', { items: items }); })
      .then(function () {
        if (reopen) { try { sessionStorage.setItem('rpbReopenCart', '1'); } catch (e) {} }
        window.location.reload();
      });
  }

  function check() {
    if (busy) return;
    busy = true;
    json('/cart.js').then(function (cart) {
      var items = cart.items || [];
      var mask = items.filter(function (i) { return i.variant_id === MASK_VARIANT; })[0];
      var subFilter = items.filter(function (i) { return i.variant_id === FILTER_VARIANT && i.selling_plan_allocation; })[0];
      var tagged = items.filter(function (i) { return i.properties && i.properties[KEY]; });
      var shouldHaveOffer = !!(mask && subFilter);
      var taggedCorrectly = shouldHaveOffer && tagged.length === 2 &&
        tagged.indexOf(mask) > -1 && tagged.indexOf(subFilter) > -1;

      // Remove the offer: tags present but the cart no longer qualifies (or the wrong lines are tagged)
      if (tagged.length && !taggedCorrectly) {
        if (getFlag()) { setFlag(null); busy = false; return; }
        setFlag('1');
        if (shouldHaveOffer) {
          var lines = tagged.slice();
          [mask, subFilter].forEach(function (l) { if (lines.indexOf(l) < 0) lines.push(l); });
          return rebuild(lines, lines.map(function (l) { return toItem(l, l === mask || l === subFilter); }));
        }
        return rebuild(tagged, tagged.map(function (l) { return toItem(l, false); }));
      }

      // Add the offer: mask + subscribed filter in the cart without tags
      if (!tagged.length && shouldHaveOffer) {
        if (getFlag()) { setFlag(null); busy = false; return; }
        setFlag('1');
        return rebuild([mask, subFilter], [toItem(mask, true), toItem(subFilter, true)]);
      }

      setFlag(null);
      busy = false;
    }).catch(function () { busy = false; });
  }

  /* Hide "Complete your kit" cards for products already in the cart */
  var UPSELL_SEL = '[data-style-id$="main_cart_container_QYinpp"],[data-style-id$="main_cart_container_At9Un6"]';
  var inCartHandles = [];
  function applyUpsellHiding() {
    document.querySelectorAll(UPSELL_SEL).forEach(function (c) {
      var cards = Array.prototype.filter.call(c.children, function (k) { return k.querySelector('a[href*="/products/"]'); });
      if (!cards.length) return;
      var visible = 0;
      cards.forEach(function (k) {
        var inCart = Array.prototype.some.call(k.querySelectorAll('a[href*="/products/"]'), function (a) {
          var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
          return m && inCartHandles.indexOf(m[1]) > -1;
        });
        k.style.display = inCart ? 'none' : '';
        if (!inCart) visible++;
      });
      c.style.display = visible ? '' : 'none';
    });
    decorateFilterOffer();
  }

  /* "First 4-pack free" call-out on the filter card in "Complete your kit".
     Only shown when the mask is in the cart (that's when the offer applies). */
  var FILTER_HANDLE = 'hepa-replacement-filter';
  var MASK_HANDLE = 'heated-nasal-therapy-mask';
  function decorateFilterOffer() {
    var maskInCart = inCartHandles.indexOf(MASK_HANDLE) > -1;
    document.querySelectorAll(UPSELL_SEL).forEach(function (c) {
      c.querySelectorAll('[data-product-handle="' + FILTER_HANDLE + '"].product-card--product-card-toggle-cart, [data-product-handle="' + FILTER_HANDLE + '"] > .product-card--product-card-toggle-cart').forEach(function (card) {
        var banner = card.querySelector('.rp-free-banner');
        var note = card.querySelector('.rp-free-note');
        var tag = card.querySelector('.rp-free-tag');
        var sw = card.querySelector('[role="switch"]');
        var priceEl = card.querySelector('.richtext-md.h5');
        if (!maskInCart || !sw) {
          [banner, note, tag].forEach(function (el) { if (el) el.remove(); });
          if (priceEl) { priceEl.style.textDecoration = ''; priceEl.style.opacity = ''; }
          return;
        }
        var on = sw.getAttribute('aria-checked') === 'true';
        if (!banner) {
          banner = document.createElement('div');
          banner.className = 'rp-free-banner';
          banner.style.cssText = 'margin:-16px -16px 12px;padding:6px 12px;border-radius:8px 8px 0 0;background:linear-gradient(90deg,#8725ac 0%,#42cceb 100%);color:#fff;font-size:13px;font-weight:700;letter-spacing:.02em;text-align:center;';
          banner.textContent = 'Your first 4-pack is FREE with Subscribe & Save';
          card.insertBefore(banner, card.firstChild);
          var cs = window.getComputedStyle(card);
          banner.style.margin = '-' + cs.paddingTop + ' -' + cs.paddingRight + ' 12px -' + cs.paddingLeft;
          banner.style.borderRadius = cs.borderTopLeftRadius + ' ' + cs.borderTopRightRadius + ' 0 0';
        }
        var row = sw.parentElement;
        if (!note && row && row.parentElement) {
          note = document.createElement('p');
          note.className = 'rp-free-note';
          note.style.cssText = 'margin:8px 0 0;font-size:13px;line-height:1.35;';
          row.parentElement.insertBefore(note, row.nextSibling);
        }
        if (note) {
          note.style.color = on ? '#067076' : '#D42583';
          note.style.fontWeight = on ? '700' : '600';
          var msg = on
            ? '✓ Your first 4-pack is free with your mask. Refills ship on the schedule you choose.'
            : 'Turn on Subscribe & Save to get this 4-pack free with your mask.';
          if (note.textContent !== msg) note.textContent = msg;
        }
        if (priceEl) {
          priceEl.style.textDecoration = on ? 'line-through' : '';
          priceEl.style.opacity = on ? '.5' : '';
          if (on && !tag) {
            tag = document.createElement('span');
            tag.className = 'rp-free-tag richtext-md h5';
            tag.style.cssText = 'font-weight:700;color:#D42583;margin-left:6px;';
            tag.textContent = 'FREE';
            priceEl.parentElement.appendChild(tag);
          }
          if (!on && tag) tag.remove();
        }
      });
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[role="switch"]')) {
      setTimeout(decorateFilterOffer, 60);
    }
  }, true);

  /* Sticky product bar: on pages with the Respyr purchase box, "Add to Cart" scrolls to the box
     (so the shopper picks Subscribe & Save or One-time there) instead of adding the product directly. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button[type="submit"]');
    if (!btn) return;
    var bar = btn.closest('[data-style-id*="main_product_bar_"]');
    var box = document.querySelector('.rpb');
    if (!bar || !box || box.contains(btn)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    // Leave room for the fixed header so the top of the box (banner) stays visible
    var top = box.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    var card = box.querySelector('.rpb-card--sub') || box;
    if (card.animate) {
      setTimeout(function () {
        card.animate([
          { boxShadow: '0 0 0 0 rgba(79,179,188,0)' },
          { boxShadow: '0 0 0 6px rgba(79,179,188,.45)' },
          { boxShadow: '0 0 0 0 rgba(79,179,188,0)' }
        ], { duration: 1200 });
      }, 450);
    }
  }, true);

  function refreshUpsells() {
    return json('/cart.js').then(function (c) {
      inCartHandles = c.items.map(function (i) { return i.handle; });
      applyUpsellHiding();
    }).catch(function () {});
  }
  var moTimer;
  new MutationObserver(function () {
    clearTimeout(moTimer);
    moTimer = setTimeout(applyUpsellHiding, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Re-check the offer and upsell cards whenever the cart changes */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(change|update|add)/.test(url)) {
      p.then(function () { setTimeout(check, 300); setTimeout(refreshUpsells, 350); }).catch(function () {});
    }
    return p;
  };

  /* After the offer rebuild reloads the page, reopen the cart drawer so the shopper stays where they were. */
  function reopenCartIfNeeded() {
    var flag = null;
    try { flag = sessionStorage.getItem('rpbReopenCart'); sessionStorage.removeItem('rpbReopenCart'); } catch (e) {}
    if (!flag) return;
    var tries = 0;
    (function go() {
      var store = window.Alpine && window.Alpine.store && window.Alpine.store('modal');
      if (store && typeof store.setId === 'function') { store.setId('modal--cart-drawer'); return; }
      if (++tries < 100) setTimeout(go, 100);
    })();
  }

  function init() { check(); refreshUpsells(); reopenCartIfNeeded(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
